import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InstrumentsService {

  private baseApi: string = environment.apiUrl + "/instruments/";
  constructor(private http: HttpClient) { }

  public getInstrument(id: string): Observable<Instrument> {
    return this.http.get<Instrument>(this.baseApi + id);
  }

  public getInstrumentsByDebt(debtId: string): Observable<Instrument[]> {
    return this.http.get<Instrument[]>(this.baseApi + "byDebt/" + debtId );
  }

  public createInstrument(request: CreateInstrumentRequest): Observable<Instrument> {
    return this.http.post<Instrument>(this.baseApi, request);
  }

  public deleteInstrument(id: string): Observable<unknown>{
    return this.http.delete(this.baseApi + id);
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }
}


export class Instrument {
  public Id: string = "";
  public DebtId: string = "";
  public IsExploratory: boolean = false;
  public InstrumentType: string = "floating";
  public NotionalTermMonths: number = 0;
  public PaymentFrequency: string = "monthly";
  public PrincipalAmount: number = 0;
  public PrincipalPercent: number = 0;
  public PrincipalAllocationUnit: string = "percent";
  public FixedRate?: number;
  public FloatingRate?: number;
  public CreatedAt: Date;
  public UpdatedAt: Date;

  public ActualPayments: PaymentSchedule;
  public ForecastSchedules: PaymentSchedule[];

  constructor() {
    this.CreatedAt = new Date();
    this.UpdatedAt = new Date();

    this.ActualPayments = new PaymentSchedule();
    this.ForecastSchedules = new Array<PaymentSchedule>();
  }

}

export class PaymentSchedule {
  public Id: string = "";
  public Name: string = "";
  public Notes: string = "";
  public SystemName: string = "";
  public IsDefault: boolean = false;
  public StartDate: Date;
  public EndDate: Date;
  public PrecedingScheduleId?: string;
  public SucceedingScheduleId?: string;
  public TotalInterest: number = 0;
  public TotalPrincipal: number = 0;
  public TotalPayments: number = 0;
  public OpeningBalance: number = 0;
  public ClosingBalance: number = 0;
  public NumberOfPayments: number = 0;
  public LatestPaymentId?: string;
  public NextPaymentId?: string;
  public CreatedAt: Date;
  public UpdatedAt: Date;

  constructor() {
    this.StartDate = new Date();
    this.EndDate = new Date();
    this.CreatedAt = new Date();
    this.UpdatedAt = new Date();
  }
}

export class CreateInstrumentRequest {
  public DebtId: string = "";
  public IsExploratory: boolean = false;
  public InstrumentType: string = "floating";
  public TermMonths: number = 0;
  public NotionalTermMonths: number = 0;
  public PaymentFrequency: string = "monthly";
  public PrincipalAmount: number = 0;
  public PrincipalPercent: number = 0;
  public PrincipalAllocationUnit: string = "percent";
  public FixedRate?: number;
  public FloatingRate?: number;
  public FirstPaymentDate: Date;

  constructor() {
    this.FirstPaymentDate = new Date();
  }

}
